export default __webpack_public_path__ + "static/media/mouth.09c1d46d.png";